// File: assets/cable-builder.js

class CableBuilder {
  constructor() {
    this.form = document.getElementById('cable-builder-form');
    this.summaryDisplay = document.getElementById('configuration-display');
    this.configDetailsUnderImage = document.getElementById('configuration-details-under-image');
    this.yourConfigSection = document.getElementById('your-configuration-section');
    this.orientationSection = document.getElementById('orientation-section');
    this.partNumberSection = document.getElementById('part-number-section');
    this.partNumberDisplay = document.getElementById('part-number-display');
    this.techSpecs = document.getElementById('tech-specs');
    this.specsContent = document.getElementById('specs-content');
    this.lengthConversion = document.getElementById('length-conversion');
    this.configuratorTop = document.querySelector('.cable-configurator-top');
    
    // Image display elements
    this.leftConnectorImage = document.getElementById('left-connector-image');
    this.rightConnectorImage = document.getElementById('right-connector-image');
    this.cableImage = document.getElementById('cable-image');
    this.leftConnectorPlaceholder = document.getElementById('left-connector-placeholder');
    this.rightConnectorPlaceholder = document.getElementById('right-connector-placeholder');
    this.cablePlaceholder = document.getElementById('cable-placeholder');
    this.leftConnectorName = document.getElementById('left-connector-name');
    this.rightConnectorName = document.getElementById('right-connector-name');
    this.cableName = document.getElementById('cable-name');
    this.cableLengthDisplay = document.getElementById('cable-length-display');
    
    // Modal elements
    this.quoteModal = document.getElementById('quote-modal');
    this.quoteForm = document.getElementById('quote-form');
    this.requestQuoteBtn = document.getElementById('request-quote-btn');
    this.closeModalBtn = document.getElementById('close-modal');
    this.cancelQuoteBtn = document.getElementById('cancel-quote');
    this.quoteConfigSummary = document.getElementById('quote-configuration-summary');
    
    // Web3forms Access Key - REPLACE WITH YOUR KEY FROM https://web3forms.com
    this.web3formsAccessKey = 'ea4b846d-dc65-4e01-a530-dcab1fbbfb09';
    
    this.cableSpecs = this.initializeCableSpecs();
    this.connectorSpecs = this.initializeConnectorSpecs();
    this.imageBasePath = this.getImageBasePath();
    
    this.init();
  }

  init() {
    if (!this.form) {
      console.error('Cable builder form not found');
      return;
    }
    
    // Add event listeners with null checks
    this.form.addEventListener('change', () => this.updateConfiguration());
    this.form.addEventListener('input', () => this.updateConfiguration());
    
    // Specific listeners for conditional logic and images
    const leftConnectorSelect = document.getElementById('left-connector');
    const rightConnectorSelect = document.getElementById('right-connector');
    const cableTypeSelect = document.getElementById('cable-type');
    const cableLengthInput = document.getElementById('cable-length');
    const lengthUnitSelect = document.getElementById('length-unit');
    
    if (leftConnectorSelect) {
      leftConnectorSelect.addEventListener('change', () => {
        this.checkOrientation();
        this.updateLeftConnectorImage();
        this.updateConfiguration();
      });
    } else {
      console.error('Left connector select not found');
    }
    
    if (rightConnectorSelect) {
      rightConnectorSelect.addEventListener('change', () => {
        this.checkOrientation();
        this.updateRightConnectorImage();
        this.updateConfiguration();
      });
    } else {
      console.error('Right connector select not found');
    }
    
    if (cableTypeSelect) {
      cableTypeSelect.addEventListener('change', () => {
        this.updateCableImage();
        this.updateConfiguration();
      });
    } else {
      console.error('Cable type select not found');
    }
    
    if (cableLengthInput) {
      cableLengthInput.addEventListener('input', () => {
        this.updateLengthConversion();
        this.updateCableLengthDisplay();
      });
    }
    
    if (lengthUnitSelect) {
      lengthUnitSelect.addEventListener('change', () => {
        this.updateLengthConversion();
        this.updateCableLengthDisplay();
      });
    }
    
    // Modal event listeners
    if (this.requestQuoteBtn) {
      this.requestQuoteBtn.addEventListener('click', () => this.openQuoteModal());
    }
    if (this.closeModalBtn) {
      this.closeModalBtn.addEventListener('click', () => this.closeQuoteModal());
    }
    if (this.cancelQuoteBtn) {
      this.cancelQuoteBtn.addEventListener('click', () => this.closeQuoteModal());
    }
    if (this.quoteForm) {
      this.quoteForm.addEventListener('submit', (e) => this.handleQuoteSubmission(e));
    }
    
    // Close modal on backdrop click
    if (this.quoteModal) {
      this.quoteModal.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-backdrop')) {
          this.closeQuoteModal();
        }
      });
    }
    
    // Initialize display
    this.updateConfiguration();
    this.initializeImages();
  }

  getImageBasePath() {
    // After uploading to Shopify Files, replace this with your actual Shopify CDN URL
    // Example: 'https://cdn.shopify.com/s/files/1/0123/4567/files/'
    // To find your URL: Upload one image, click on it in Files, copy the URL up to the filename
    return 'https://cdn.shopify.com/s/files/1/0700/0231/1387/files/';
  }

  initializeCableSpecs() {
    return {

      // 50Ω Flexible Coax - Standard Performance
      'rg141': {
        name: 'RG141',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.19"',
        jacketMaterial: 'PTFE (FG)',
        numShields: '1.0',
        attenuation: '13.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.19"',
        image: 'rg141-cable.jpg'
      },
      'rg142': {
        name: 'RG142',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'FEP',
        numShields: '2.0',
        attenuation: '12.5 dB/ft @ 1GHz',
        rfShielding: '70.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.98"',
        bendRadiusRepeated: '1.97"',
        diameter: '0.195"',
        image: 'rg142-cable.jpg'
      },
      'rg174': {
        name: 'RG174',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.11"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '32.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.11"',
        image: 'rg174-cable.jpg'
      },
      'rg178': {
        name: 'RG178',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.072"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '44.41 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '0.4"',
        diameter: '0.072"',
        image: 'rg178-cable.jpg'
      },
      'rg188': {
        name: 'RG188',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.11"',
        jacketMaterial: 'PTFE',
        numShields: '1.0',
        attenuation: '26.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.11"',
        image: 'rg188-cable.jpg'
      },
      'rg196': {
        name: 'RG196',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: 'N/A',
        jacketDiameter: '0.08"',
        jacketMaterial: 'PTFE',
        numShields: '1.0',
        attenuation: '49.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.08"',
        image: 'rg196-cable.jpg'
      },
      'rg213': {
        name: 'RG213',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '9.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +70.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.6"',
        diameter: '0.405"',
        image: 'rg213-cable.jpg'
      },
      'rg214': {
        name: 'RG214',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.425"',
        jacketMaterial: 'PVC',
        numShields: '2.0',
        attenuation: '7.32 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +180.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.6"',
        diameter: '0.425"',
        image: 'rg214-cable.jpg'
      },
      'rg217': {
        name: 'RG217',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.545"',
        jacketMaterial: 'PVC',
        numShields: '2.0',
        attenuation: '5.8 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.545"',
        image: 'rg217-cable.jpg'
      },
      'rg218': {
        name: 'RG218',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.87"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '5.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.87"',
        image: 'rg218-cable.jpg'
      },
      'rg223': {
        name: 'RG223',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.209"',
        jacketMaterial: 'PVC',
        numShields: '2.0',
        attenuation: '13.41 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '12.4 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.0"',
        diameter: '0.209"',
        image: 'rg223-cable.jpg'
      },
      'rg225': {
        name: 'RG225',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.43"',
        jacketMaterial: 'PTFE (FG)',
        numShields: '2.0',
        attenuation: '7.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.43"',
        image: 'rg225-cable.jpg'
      },
      'rg303': {
        name: 'RG303',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: 'N/A',
        jacketDiameter: '0.17"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '14.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: 'N/A',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.17"',
        image: 'rg303-cable.jpg'
      },
      'rg316': {
        name: 'RG316',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.0%',
        jacketDiameter: '0.102"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '38.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.102"',
        image: 'rg316-cable.jpg'
      },
      'rg316-ds': {
        name: 'RG316-DS',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: '0.114"',
        jacketMaterial: 'FEP',
        numShields: '2.0',
        attenuation: '29.0 dB/ft @ 1GHz',
        rfShielding: '85.0 dB',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: '0.59"',
        bendRadiusRepeated: '1.57"',
        diameter: '0.114"',
        image: 'rg316-ds-cable.jpg'
      },
      'rg393': {
        name: 'RG393',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: '0.39"',
        jacketMaterial: 'FEP',
        numShields: '2.0',
        attenuation: '7.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '3.9"',
        diameter: '0.39"',
        image: 'rg393-cable.jpg'
      },
      'rg400': {
        name: 'RG400',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'FEP',
        numShields: '2.0',
        attenuation: '14.7 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '12.4 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '19.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.0"',
        diameter: '0.195"',
        image: 'rg400-cable.jpg'
      },
      'rg55': {
        name: 'RG55',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '53Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.202"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '16.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: 'N/A',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.202"',
        image: 'rg55-cable.jpg'
      },
      'rg58': {
        name: 'RG58',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '65.9%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PVC (NC)',
        numShields: '1.0',
        attenuation: '20.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '5.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '19.0',
        bendRadiusOnce: '0.98"',
        bendRadiusRepeated: '1.96"',
        diameter: '0.195"',
        image: 'rg58-cable.jpg'
      },
      'rg58-p': {
        name: 'RG58-P',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '53Ω',
        dielectricType: 'FEP',
        velocity: '69.5%',
        jacketDiameter: '0.159"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '17.3 dB/ft @ 1GHz',
        rfShielding: '45.0 dB',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '2.0"',
        diameter: '0.159"',
        image: 'rg58-p-cable.jpg'
      },
      'rg8': {
        name: 'RG8',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PVC (NC)',
        numShields: '1.0',
        attenuation: '8.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.405"',
        image: 'rg8-cable.jpg'
      },
      'rg8x': {
        name: 'RG8X',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: 'N/A',
        jacketDiameter: '0.242"',
        jacketMaterial: 'PVC (NC)',
        numShields: '1.0',
        attenuation: '13.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '19.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.242"',
        image: 'rg8x-cable.jpg'
      },

      // 50Ω Flexible Coax - Low Loss
      'lmr-100a-fr': {
        name: 'LMR-100A-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.11"',
        jacketMaterial: 'FRPE',
        numShields: '2.0',
        attenuation: '24.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.25"',
        bendRadiusRepeated: '1.0"',
        diameter: '0.11"',
        image: 'lmr-100a-fr-cable.jpg'
      },
      'lmr-100a': {
        name: 'LMR-100A',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.11"',
        jacketMaterial: 'PVC',
        numShields: '2.0',
        attenuation: '24.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.25"',
        bendRadiusRepeated: '1.0"',
        diameter: '0.11"',
        image: 'lmr-100a-cable.jpg'
      },
      'lmr-100a-uf': {
        name: 'LMR-100A-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.11"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '24.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: '0.25"',
        bendRadiusRepeated: '1.0"',
        diameter: '0.11"',
        image: 'lmr-100a-uf-cable.jpg'
      },
      'lmr-195': {
        name: 'LMR-195',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '11.8 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-195-cable.jpg'
      },
      'lmr-195-fr': {
        name: 'LMR-195-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '76.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'FRPE',
        numShields: '2.0',
        attenuation: '11.8 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-195-fr-cable.jpg'
      },
      'lmr-195-llpl': {
        name: 'LMR-195-LLPL',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE (LD)',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PVC (FR)',
        numShields: '2.0',
        attenuation: '11.8 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-195-llpl-cable.jpg'
      },
      'lmr-195-llpx': {
        name: 'LMR-195-LLPX',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE (LD)',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PVC (FR)',
        numShields: '2.0',
        attenuation: '11.8 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-195-llpx-cable.jpg'
      },
      'lmr-195-uf': {
        name: 'LMR-195-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '74.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '13.89 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-195-uf-cable.jpg'
      },
      'lmr-200': {
        name: 'LMR-200',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '83.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '10.5 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-200-cable.jpg'
      },
      'lmr-200-fr': {
        name: 'LMR-200-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: '83.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'FRPE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +185.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-200-fr-cable.jpg'
      },
      'lmr-200-uf': {
        name: 'LMR-200-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '83.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '12.18 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: 'N/A',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-200-uf-cable.jpg'
      },
      'lmr-240': {
        name: 'LMR-240',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '8.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-cable.jpg'
      },
      'lmr-240-db': {
        name: 'LMR-240-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '7.66 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-db-cable.jpg'
      },
      'lmr-240-fr': {
        name: 'LMR-240-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'FRPE',
        numShields: '2.0',
        attenuation: '7.99 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-fr-cable.jpg'
      },
      'lmr-240-llpx': {
        name: 'LMR-240-LLPX',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'Fluoropolymer',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-llpx-cable.jpg'
      },
      'lmr-240-uf': {
        name: 'LMR-240-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '9.19 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: 'N/A',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-uf-cable.jpg'
      },
      'lmr-400': {
        name: 'LMR-400',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '4.25 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-cable.jpg'
      },
      'lmr-400-db': {
        name: 'LMR-400-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '4.15 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-db-cable.jpg'
      },
      'lmr-400-fr': {
        name: 'LMR-400-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '84.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'FRPE',
        numShields: '2.0',
        attenuation: '4.1 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-fr-cable.jpg'
      },
      'lmr-400-llpx': {
        name: 'LMR-400-LLPX',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE (LD)',
        velocity: '76.0%',
        jacketDiameter: '0.37"',
        jacketMaterial: 'Fluoropolymer',
        numShields: '2.0',
        attenuation: '4.2 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '4.0"',
        diameter: '0.37"',
        image: 'lmr-400-llpx-cable.jpg'
      },
      'lmr-400-uf': {
        name: 'LMR-400-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '5.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: 'N/A',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-uf-cable.jpg'
      },
      'lmr-500': {
        name: 'LMR-500',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '86.0%',
        jacketDiameter: '0.5"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '3.1 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: '5.0"',
        diameter: '0.5"',
        image: 'lmr-500-cable.jpg'
      },
      'lmr-500-db': {
        name: 'LMR-500-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '86.0%',
        jacketDiameter: '0.5"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '3.1 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: '5.0"',
        diameter: '0.5"',
        image: 'lmr-500-db-cable.jpg'
      },
      'lmr-500-uf': {
        name: 'LMR-500-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '85.0%',
        jacketDiameter: '0.5"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '4.0 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: '5.0"',
        diameter: '0.5"',
        image: 'lmr-500-uf-cable.jpg'
      },
      'lmr-600': {
        name: 'LMR-600',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '2.62 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'lmr-600-cable.jpg'
      },
      'lmr-600-db': {
        name: 'LMR-600-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '2.62 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'lmr-600-db-cable.jpg'
      },
      'lmr-600-fr': {
        name: 'LMR-600-FR',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '85.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '2.64 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'lmr-600-fr-cable.jpg'
      },
      'lmr-600-llpx': {
        name: 'LMR-600-LLPX',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.565"',
        jacketMaterial: 'Fluoropolymer',
        numShields: 'N/A',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.565"',
        image: 'lmr-600-llpx-cable.jpg'
      },
      'lmr-600-uf': {
        name: 'LMR-600-UF',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'TPE',
        numShields: '2.0',
        attenuation: '3.17 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Stranded',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'lmr-600-uf-cable.jpg'
      },
      'lmr-900-db': {
        name: 'LMR-900-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '87.0%',
        jacketDiameter: '0.87"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '6.0 GHz',
        tempRange: 'N/A',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '3.0"',
        bendRadiusRepeated: '9.0"',
        diameter: '0.87"',
        image: 'lmr-900-db-cable.jpg'
      },
      'lmr-lw195': {
        name: 'LMR-LW195',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '11.67 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'lmr-lw195-cable.jpg'
      },
      'lmr-lw240': {
        name: 'LMR-LW240',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '7.99 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-lw240-cable.jpg'
      },
      'lmr-lw400': {
        name: 'LMR-LW400',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '84.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '4.1 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-lw400-cable.jpg'
      },
      'lmr-lw600': {
        name: 'LMR-LW600',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '85.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: '2.64 dB/ft @ 1GHz',
        rfShielding: '90.0 dB',
        maxFreq: '8.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'lmr-lw600-cable.jpg'
      },

      // 50Ω Semi-Rigid Coax
      'rg402-tinned': {
        name: 'RG402 Tinned',
        design: 'Standard',
        flexType: 'Semi-Rigid',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: 'N/A',
        attenuation: '12.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '36.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: 'N/A',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: 'N/A',
        diameter: 'N/A',
        image: 'rg402-tinned-cable.jpg'
      },
      'rg405-tinned': {
        name: 'RG405 Tinned',
        design: 'Standard',
        flexType: 'Semi-Rigid',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: 'N/A',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: '1.0',
        attenuation: '22.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '40.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.05"',
        bendRadiusRepeated: 'N/A',
        diameter: 'N/A',
        image: 'rg405-tinned-cable.jpg'
      },
      'rg401': {
        name: 'RG401',
        design: 'Standard',
        flexType: 'Semi-Rigid',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: '1.0',
        attenuation: '7.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '20.0 GHz',
        tempRange: '-55°C to +150.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '0.5"',
        diameter: 'N/A',
        image: 'rg401-cable.jpg'
      },
      'rg402': {
        name: 'RG402',
        design: 'Standard',
        flexType: 'Semi-Rigid',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: '1.0',
        attenuation: '12.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '33.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '0.25"',
        diameter: 'N/A',
        image: 'rg402-cable.jpg'
      },
      'rg405': {
        name: 'RG405',
        design: 'Standard',
        flexType: 'Semi-Rigid',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '69.5%',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: '1.0',
        attenuation: '22.0 dB/ft @ 1GHz',
        rfShielding: '-110.0 dB',
        maxFreq: '40.0 GHz',
        tempRange: '-55°C to +125.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '0.05"',
        diameter: 'N/A',
        image: 'rg405-cable.jpg'
      },

      // 50Ω Corrugated Coax
      '1-2-flexible': {
        name: '1/2" Flexible',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '88.0%',
        jacketDiameter: '0.629"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: '2.2 dB/ft @ 1GHz',
        rfShielding: '120.0 dB',
        maxFreq: '8.8 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '2.75"',
        bendRadiusRepeated: '4.72"',
        diameter: '0.629"',
        image: '1-2-flexible-cable.jpg'
      },
      '1-2-superflexible': {
        name: '1/2" Superflexible',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '82.0%',
        jacketDiameter: '0.519"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: '3.41 dB/ft @ 1GHz',
        rfShielding: '120.0 dB',
        maxFreq: '10.2 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.6"',
        bendRadiusRepeated: '1.18"',
        diameter: '0.519"',
        image: '1-2-superflexible-cable.jpg'
      },
      '1-4-superflexible': {
        name: '1/4" Superflexible',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '82.0%',
        jacketDiameter: '0.303"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: '5.85 dB/ft @ 1GHz',
        rfShielding: '120.0 dB',
        maxFreq: '20.4 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '1.0"',
        diameter: '0.303"',
        image: '1-4-superflexible-cable.jpg'
      },
      'spf-250': {
        name: 'SPF-250',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.303"',
        jacketMaterial: 'FRPE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.303"',
        image: 'spf-250-cable.jpg'
      },
      'spf-375': {
        name: 'SPF-375',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.435"',
        jacketMaterial: 'FRPE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.75"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.435"',
        image: 'spf-375-cable.jpg'
      },
      'spf-500': {
        name: 'SPF-500',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.545"',
        jacketMaterial: 'FRPE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '2.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.545"',
        image: 'spf-500-cable.jpg'
      },
      'spo-250': {
        name: 'SPO-250',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.303"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.303"',
        image: 'spo-250-cable.jpg'
      },
      'spo-375': {
        name: 'SPO-375',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.43"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.75"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.43"',
        image: 'spo-375-cable.jpg'
      },
      'spo-500': {
        name: 'SPO-500',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Foam PE',
        velocity: '83.0%',
        jacketDiameter: '0.53"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '2.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.53"',
        image: 'spo-500-cable.jpg'
      },
      'spp-250-llpl': {
        name: 'SPP-250-LLPL',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.28"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '5.5 dB/ft @ 1GHz',
        rfShielding: '100.0 dB',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.28"',
        image: 'spp-250-llpl-cable.jpg'
      },
      'spp-375-llpl': {
        name: 'SPP-375-LLPL',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'Microporous PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.402"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.25"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.402"',
        image: 'spp-375-llpl-cable.jpg'
      },
      'spp-500-llpl': {
        name: 'SPP-500-LLPL',
        design: 'Low Loss',
        flexType: 'Corrugated',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.5"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.5"',
        image: 'spp-500-llpl-cable.jpg'
      },

      // 50Ω Low PIM
      'tcom-195': {
        name: 'TCOM-195',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'PE',
        numShields: '3.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '18.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'tcom-195-cable.jpg'
      },
      'tcom-195-fr': {
        name: 'TCOM-195-FR',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '80.0%',
        jacketDiameter: '0.195"',
        jacketMaterial: 'FRPE',
        numShields: '3.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '18.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.5"',
        bendRadiusRepeated: '2.0"',
        diameter: '0.195"',
        image: 'tcom-195-fr-cable.jpg'
      },
      'tcom-240': {
        name: 'TCOM-240',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'tcom-240-cable.jpg'
      },
      'tcom-240-fr': {
        name: 'TCOM-240-FR',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'FRPE',
        numShields: '3.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '18.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'tcom-240-fr-cable.jpg'
      },
      'tcom-400': {
        name: 'TCOM-400',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'tcom-400-cable.jpg'
      },
      'tcom-400-fr': {
        name: 'TCOM-400-FR',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'FRPE',
        numShields: '3.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'tcom-400-fr-cable.jpg'
      },
      'tcom-600': {
        name: 'TCOM-600',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'tcom-600-cable.jpg'
      },
      'tcom-600-fr': {
        name: 'TCOM-600-FR',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE (F)',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'FRPE',
        numShields: '3.0',
        attenuation: 'N/A',
        rfShielding: '100.0 dB',
        maxFreq: '10.0 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: '6.0"',
        diameter: '0.59"',
        image: 'tcom-600-fr-cable.jpg'
      },
      'tft-5g-402': {
        name: 'TFT-5G-402',
        design: 'Low PIM',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PTFE',
        velocity: '76.0%',
        jacketDiameter: '0.16"',
        jacketMaterial: 'FEP',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '80.0 dB',
        maxFreq: '6.0 GHz',
        tempRange: '-55°C to +150.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.16"',
        image: 'tft-5g-402-cable.jpg'
      },

      // 50Ω Non-Magnetic
      'rg174nm': {
        name: 'RG174NM',
        design: 'non-magnetic',
        flexType: 'Flexible',
        impedance: '50Ω',
        dielectricType: 'PE',
        velocity: 'N/A',
        jacketDiameter: 'N/A',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '0.1 GHz',
        tempRange: '-55°C to +105.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.5"',
        diameter: 'N/A',
        image: 'rg174nm-cable.jpg'
      },

      // 75Ω Flexible Coax
      'mini-59': {
        name: 'MINI 59',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE (F)',
        velocity: '83.0%',
        jacketDiameter: '0.159"',
        jacketMaterial: 'PVC',
        numShields: '2.0',
        attenuation: '10.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +75.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.5"',
        bendRadiusRepeated: 'N/A',
        diameter: '0.159"',
        image: 'mini-59-cable.jpg'
      },
      'rg11': {
        name: 'RG11',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '8.1 dB/ft @ 1GHz',
        rfShielding: '14.0 dB',
        maxFreq: '5.0 GHz',
        tempRange: '-55°C to +180.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '4.5"',
        diameter: '0.405"',
        image: 'rg11-cable.jpg'
      },
      'rg179': {
        name: 'RG179',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.1"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '29.15 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '0.4"',
        diameter: '0.1"',
        image: 'rg179-cable.jpg'
      },
      'rg187': {
        name: 'RG187',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.102"',
        jacketMaterial: 'PTFE',
        numShields: '1.0',
        attenuation: '25.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: 'N/A',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.102"',
        image: 'rg187-cable.jpg'
      },
      'rg302': {
        name: 'RG302',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PTFE',
        velocity: '69.0%',
        jacketDiameter: '0.206"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: '13.0 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Solid',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.206"',
        image: 'rg302-cable.jpg'
      },
      'rg59': {
        name: 'RG59',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.242"',
        jacketMaterial: 'PVC (NC)',
        numShields: '1.0',
        attenuation: '11.5 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +70.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.242"',
        image: 'rg59-cable.jpg'
      },
      'rg59-p': {
        name: 'RG59-P',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'FEP (F)',
        velocity: '82.0%',
        jacketDiameter: '0.194"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '10.9 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.194"',
        image: 'rg59-p-cable.jpg'
      },
      'rg6': {
        name: 'RG6',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.332"',
        jacketMaterial: 'PVC (NC)',
        numShields: '2.0',
        attenuation: '11.0 dB/ft @ 1GHz',
        rfShielding: '9.0 dB',
        maxFreq: '0.0 GHz',
        tempRange: '-55°C to +180.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '3.5"',
        diameter: '0.332"',
        image: 'rg6-cable.jpg'
      },
      'rg6-catv': {
        name: 'RG6-CATV',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.278"',
        jacketMaterial: 'PVC (NC)',
        numShields: '3.0',
        attenuation: '6.5 dB/ft @ 1GHz',
        rfShielding: '57.0 dB',
        maxFreq: '0.0 GHz',
        tempRange: '-55°C to +380.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.38"',
        diameter: '0.278"',
        image: 'rg6-catv-cable.jpg'
      },

      // 75Ω Flexible Coax - Low Loss
      'lmr-240-75-db': {
        name: 'LMR-240-75-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'Foam PE',
        velocity: '84.0%',
        jacketDiameter: '0.24"',
        jacketMaterial: 'PE',
        numShields: 'N/A',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '2.5 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: '0.75"',
        bendRadiusRepeated: '2.5"',
        diameter: '0.24"',
        image: 'lmr-240-75-db-cable.jpg'
      },
      'lmr-400-75': {
        name: 'LMR-400-75',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PE (F)',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: '2.0',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '2.5 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-75-cable.jpg'
      },
      'lmr-400-75-db': {
        name: 'LMR-400-75-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'Foam PE',
        velocity: '85.0%',
        jacketDiameter: '0.405"',
        jacketMaterial: 'PE',
        numShields: 'N/A',
        attenuation: 'N/A',
        rfShielding: '90.0 dB',
        maxFreq: '2.5 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: '1.0"',
        bendRadiusRepeated: '4.0"',
        diameter: '0.405"',
        image: 'lmr-400-75-db-cable.jpg'
      },
      'lmr-600-75-db': {
        name: 'LMR-600-75-DB',
        design: 'Low Loss',
        flexType: 'Flexible',
        impedance: '75Ω',
        dielectricType: 'PTFE',
        velocity: '87.0%',
        jacketDiameter: '0.59"',
        jacketMaterial: 'PE',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '2.5 GHz',
        tempRange: '-55°C to +85.0°C',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '1.0"',
        diameter: '0.59"',
        image: 'lmr-600-75-db-cable.jpg'
      },

      // 93Ω Flexible Coax
      'rg62': {
        name: 'RG62',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '93Ω',
        dielectricType: 'PE (AS)',
        velocity: '83.0%',
        jacketDiameter: '0.239"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '8.7 dB/ft @ 1GHz',
        rfShielding: '45.0 dB',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Solid',
        conductorStrands: '1.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: '2.5"',
        diameter: '0.239"',
        image: 'rg62-cable.jpg'
      },

      // 95Ω Flexible Coax
      'rg180': {
        name: 'RG180',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '95Ω',
        dielectricType: 'PTFE',
        velocity: '70.0%',
        jacketDiameter: '0.141"',
        jacketMaterial: 'FEP',
        numShields: '1.0',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: '3.0 GHz',
        tempRange: '-55°C to +200.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.141"',
        image: 'rg180-cable.jpg'
      },

      // 78Ω Twinax
      'rg108': {
        name: 'RG108',
        design: 'Standard',
        flexType: 'Flexible',
        impedance: '78Ω',
        dielectricType: 'PE',
        velocity: '66.0%',
        jacketDiameter: '0.235"',
        jacketMaterial: 'PVC',
        numShields: '1.0',
        attenuation: '34.6 dB/ft @ 1GHz',
        rfShielding: 'N/A',
        maxFreq: '1.0 GHz',
        tempRange: '-55°C to +80.0°C',
        conductorType: 'Stranded',
        conductorStrands: '7.0',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: '0.235"',
        image: 'rg108-cable.jpg'
      },
      'other-cable': {
        name: 'Other Cable',
        design: 'Custom',
        flexType: 'Various',
        impedance: 'N/A',
        dielectricType: 'N/A',
        velocity: 'N/A',
        jacketDiameter: 'N/A',
        jacketMaterial: 'N/A',
        numShields: 'N/A',
        attenuation: 'N/A',
        rfShielding: 'N/A',
        maxFreq: 'N/A',
        tempRange: 'N/A',
        conductorType: 'N/A',
        conductorStrands: 'N/A',
        bendRadiusOnce: 'N/A',
        bendRadiusRepeated: 'N/A',
        diameter: 'N/A',
        image: 'other-cable.jpg'
      },
    };
  }

  initializeConnectorSpecs() {
    return {
      // SMA Series
      'sma-male': { name: 'SMA Male - Straight', series: 'SMA', gender: 'Male', type: 'Straight', orientable: true, image: 'sma-male.jpg' },
      'sma-male-ra': { name: 'SMA Male - Right Angle', series: 'SMA', gender: 'Male', type: 'Right Angle', orientable: true, image: 'sma-male-ra.jpg' },
      'sma-male-bulkhead': { name: 'SMA Male - Bulkhead', series: 'SMA', gender: 'Male', type: 'Bulkhead', orientable: false, image: 'sma-male-bulkhead.jpg' },
      'sma-female': { name: 'SMA Female - Straight', series: 'SMA', gender: 'Female', type: 'Straight', orientable: true, image: 'sma-female.jpg' },
      'sma-female-ra': { name: 'SMA Female - Right Angle', series: 'SMA', gender: 'Female', type: 'Right Angle', orientable: true, image: 'sma-female-ra.jpg' },
      'sma-female-bulkhead': { name: 'SMA Female - Bulkhead', series: 'SMA', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'sma-female-bulkhead.jpg' },
      'rp-sma-male': { name: 'RP-SMA Male', series: 'SMA', gender: 'Male', type: 'Reverse Polarity', orientable: true, image: 'rp-sma-male.jpg' },
      'rp-sma-female': { name: 'RP-SMA Female', series: 'SMA', gender: 'Female', type: 'Reverse Polarity', orientable: true, image: 'rp-sma-female.jpg' },
      
      // SMB Series
      'smb-male': { name: 'SMB Male - Straight', series: 'SMB', gender: 'Male', type: 'Straight', orientable: true, image: 'smb-male.jpg' },
      'smb-male-ra': { name: 'SMB Male - Right Angle', series: 'SMB', gender: 'Male', type: 'Right Angle', orientable: true, image: 'smb-male-ra.jpg' },
      'smb-female': { name: 'SMB Female - Straight', series: 'SMB', gender: 'Female', type: 'Straight', orientable: true, image: 'smb-female.jpg' },
      'smb-female-ra': { name: 'SMB Female - Right Angle', series: 'SMB', gender: 'Female', type: 'Right Angle', orientable: true, image: 'smb-female-ra.jpg' },
      
      // SMC Series
      'smc-male': { name: 'SMC Male - Straight', series: 'SMC', gender: 'Male', type: 'Straight', orientable: true, image: 'smc-male.jpg' },
      'smc-male-ra': { name: 'SMC Male - Right Angle', series: 'SMC', gender: 'Male', type: 'Right Angle', orientable: true, image: 'smc-male-ra.jpg' },
      'smc-female': { name: 'SMC Female - Straight', series: 'SMC', gender: 'Female', type: 'Straight', orientable: true, image: 'smc-female.jpg' },
      'smc-female-ra': { name: 'SMC Female - Right Angle', series: 'SMC', gender: 'Female', type: 'Right Angle', orientable: true, image: 'smc-female-ra.jpg' },
      
      // BNC Series
      'bnc-male-50': { name: 'BNC Male 50Ω - Straight', series: 'BNC', gender: 'Male', impedance: '50Ω', type: 'Straight', orientable: true, image: 'bnc-male-50.jpg' },
      'bnc-male-50-ra': { name: 'BNC Male 50Ω - Right Angle', series: 'BNC', gender: 'Male', impedance: '50Ω', type: 'Right Angle', orientable: true, image: 'bnc-male-50-ra.jpg' },
      'bnc-male-50-bulkhead': { name: 'BNC Male 50Ω - Bulkhead', series: 'BNC', gender: 'Male', impedance: '50Ω', type: 'Bulkhead', orientable: false, image: 'bnc-male-50-bulkhead.jpg' },
      'bnc-female-50': { name: 'BNC Female 50Ω - Straight', series: 'BNC', gender: 'Female', impedance: '50Ω', type: 'Straight', orientable: true, image: 'bnc-female-50.jpg' },
      'bnc-female-50-bulkhead': { name: 'BNC Female 50Ω - Bulkhead', series: 'BNC', gender: 'Female', impedance: '50Ω', type: 'Bulkhead', orientable: false, image: 'bnc-female-50-bulkhead.jpg' },
      'bnc-male-75': { name: 'BNC Male 75Ω - Straight', series: 'BNC', gender: 'Male', impedance: '75Ω', type: 'Straight', orientable: true, image: 'bnc-male-75.jpg' },
      'bnc-female-75': { name: 'BNC Female 75Ω - Straight', series: 'BNC', gender: 'Female', impedance: '75Ω', type: 'Straight', orientable: true, image: 'bnc-female-75.jpg' },
      
      // N-Type Series
      'n-male': { name: 'N-Type Male - Straight', series: 'N-Type', gender: 'Male', type: 'Straight', orientable: true, image: 'n-male.jpg' },
      'n-male-ra': { name: 'N-Type Male - Right Angle', series: 'N-Type', gender: 'Male', type: 'Right Angle', orientable: true, image: 'n-male-ra.jpg' },
      'n-male-bulkhead': { name: 'N-Type Male - Bulkhead', series: 'N-Type', gender: 'Male', type: 'Bulkhead', orientable: false, image: 'n-male-bulkhead.jpg' },
      'n-female': { name: 'N-Type Female - Straight', series: 'N-Type', gender: 'Female', type: 'Straight', orientable: true, image: 'n-female.jpg' },
      'n-female-bulkhead': { name: 'N-Type Female - Bulkhead', series: 'N-Type', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'n-female-bulkhead.jpg' },
      'rp-n-male': { name: 'RP-N-Type Male', series: 'N-Type', gender: 'Male', type: 'Reverse Polarity', orientable: true, image: 'rp-n-male.jpg' },
      'rp-n-female': { name: 'RP-N-Type Female', series: 'N-Type', gender: 'Female', type: 'Reverse Polarity', orientable: true, image: 'rp-n-female.jpg' },
      
      // TNC Series
      'tnc-male': { name: 'TNC Male - Straight', series: 'TNC', gender: 'Male', type: 'Straight', orientable: true, image: 'tnc-male.jpg' },
      'tnc-male-ra': { name: 'TNC Male - Right Angle', series: 'TNC', gender: 'Male', type: 'Right Angle', orientable: true, image: 'tnc-male-ra.jpg' },
      'tnc-female': { name: 'TNC Female - Straight', series: 'TNC', gender: 'Female', type: 'Straight', orientable: true, image: 'tnc-female.jpg' },
      'tnc-female-ra': { name: 'TNC Female - Right Angle', series: 'TNC', gender: 'Female', type: 'Right Angle', orientable: true, image: 'tnc-female-ra.jpg' },
      'rp-tnc-male': { name: 'RP-TNC Male', series: 'TNC', gender: 'Male', type: 'Reverse Polarity', orientable: true, image: 'rp-tnc-male.jpg' },
      'rp-tnc-female': { name: 'RP-TNC Female', series: 'TNC', gender: 'Female', type: 'Reverse Polarity', orientable: true, image: 'rp-tnc-female.jpg' },
      
      // UHF/PL Series
      'pl-259': { name: 'PL-259 (UHF Male)', series: 'UHF', gender: 'Male', type: 'Straight', orientable: false, image: 'pl-259.jpg' },
      'so-239': { name: 'SO-239 (UHF Female)', series: 'UHF', gender: 'Female', type: 'Straight', orientable: false, image: 'so-239.jpg' },
      
      // MCX Series
      'mcx-male': { name: 'MCX Male - Straight', series: 'MCX', gender: 'Male', type: 'Straight', orientable: true, image: 'mcx-male.jpg' },
      'mcx-male-ra': { name: 'MCX Male - Right Angle', series: 'MCX', gender: 'Male', type: 'Right Angle', orientable: true, image: 'mcx-male-ra.jpg' },
      'mcx-female': { name: 'MCX Female - Straight', series: 'MCX', gender: 'Female', type: 'Straight', orientable: true, image: 'mcx-female.jpg' },
      'mcx-female-ra': { name: 'MCX Female - Right Angle', series: 'MCX', gender: 'Female', type: 'Right Angle', orientable: true, image: 'mcx-female-ra.jpg' },
      
      // MMCX Series
      'mmcx-male': { name: 'MMCX Male - Straight', series: 'MMCX', gender: 'Male', type: 'Straight', orientable: true, image: 'mmcx-male.jpg' },
      'mmcx-male-ra': { name: 'MMCX Male - Right Angle', series: 'MMCX', gender: 'Male', type: 'Right Angle', orientable: true, image: 'mmcx-male-ra.jpg' },
      'mmcx-female': { name: 'MMCX Female - Straight', series: 'MMCX', gender: 'Female', type: 'Straight', orientable: true, image: 'mmcx-female.jpg' },
      'mmcx-female-ra': { name: 'MMCX Female - Right Angle', series: 'MMCX', gender: 'Female', type: 'Right Angle', orientable: true, image: 'mmcx-female-ra.jpg' },
      
      // F-Type Series
      'f-male': { name: 'F-Type Male - Straight', series: 'F-Type', gender: 'Male', type: 'Straight', orientable: true, image: 'f-male.jpg' },
      'f-male-ra': { name: 'F-Type Male - Right Angle', series: 'F-Type', gender: 'Male', type: 'Right Angle', orientable: true, image: 'f-male-ra.jpg' },
      'f-female': { name: 'F-Type Female - Straight', series: 'F-Type', gender: 'Female', type: 'Straight', orientable: false, image: 'f-female.jpg' },
      'f-female-bulkhead': { name: 'F-Type Female - Bulkhead', series: 'F-Type', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'f-female-bulkhead.jpg' },
      
      // QMA Series
      'qma-male': { name: 'QMA Male - Straight', series: 'QMA', gender: 'Male', type: 'Straight', orientable: true, image: 'qma-male.jpg' },
      'qma-male-ra': { name: 'QMA Male - Right Angle', series: 'QMA', gender: 'Male', type: 'Right Angle', orientable: true, image: 'qma-male-ra.jpg' },
      'qma-female': { name: 'QMA Female - Straight', series: 'QMA', gender: 'Female', type: 'Straight', orientable: true, image: 'qma-female.jpg' },
      'qma-female-bulkhead': { name: 'QMA Female - Bulkhead', series: 'QMA', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'qma-female-bulkhead.jpg' },
      
      // QN Series
      'qn-male': { name: 'QN Male - Straight', series: 'QN', gender: 'Male', type: 'Straight', orientable: true, image: 'qn-male.jpg' },
      'qn-male-ra': { name: 'QN Male - Right Angle', series: 'QN', gender: 'Male', type: 'Right Angle', orientable: true, image: 'qn-male-ra.jpg' },
      'qn-female': { name: 'QN Female - Straight', series: 'QN', gender: 'Female', type: 'Straight', orientable: true, image: 'qn-female.jpg' },
      'qn-female-bulkhead': { name: 'QN Female - Bulkhead', series: 'QN', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'qn-female-bulkhead.jpg' },
      
      // 7/16 DIN Series
      '716din-male': { name: '7/16 DIN Male - Straight', series: '7/16 DIN', gender: 'Male', type: 'Straight', orientable: true, image: '716din-male.jpg' },
      '716din-male-ra': { name: '7/16 DIN Male - Right Angle', series: '7/16 DIN', gender: 'Male', type: 'Right Angle', orientable: true, image: '716din-male-ra.jpg' },
      '716din-female': { name: '7/16 DIN Female - Straight', series: '7/16 DIN', gender: 'Female', type: 'Straight', orientable: true, image: '716din-female.jpg' },
      '716din-female-bulkhead': { name: '7/16 DIN Female - Bulkhead', series: '7/16 DIN', gender: 'Female', type: 'Bulkhead', orientable: false, image: '716din-female-bulkhead.jpg' },
      
      // U.FL Series
      'ufl-male': { name: 'U.FL Male - Straight', series: 'U.FL', gender: 'Male', type: 'Straight', orientable: true, image: 'ufl-male.jpg' },
      'ufl-female': { name: 'U.FL Female - Straight', series: 'U.FL', gender: 'Female', type: 'Straight', orientable: true, image: 'ufl-female.jpg' },
      
      // Open Terminal
      'open-terminal': { name: 'Open Terminal (Bare Wire)', series: 'Open', gender: 'N/A', type: 'Terminal', orientable: false, image: 'open-terminal.jpg' },
      
      // 1.0/2.3 Series
      '1023-male': { name: '1.0/2.3 Male', series: '1.0/2.3', gender: 'Male', type: 'Standard', orientable: false, image: '1023-male.jpg' },
      '1023-male-ra': { name: '1.0/2.3 Male - Right Angle', series: '1.0/2.3', gender: 'Male', type: 'Right Angle', orientable: true, image: '1023-male-ra.jpg' },
      '1023-female-bulkhead': { name: '1.0/2.3 Female - Bulkhead', series: '1.0/2.3', gender: 'Female', type: 'Bulkhead', orientable: false, image: '1023-female-bulkhead.jpg' },
      '1023-female-ra-bulkhead': { name: '1.0/2.3 Female - Right Angle Bulkhead', series: '1.0/2.3', gender: 'Female', type: 'Right Angle Bulkhead', orientable: false, image: '1023-female-ra-bulkhead.jpg' },
      
      // 4.3/10 DIN Series
      '4310din-male': { name: '4.3/10 DIN Male', series: '4.3/10 DIN', gender: 'Male', type: 'Standard', orientable: false, image: '4310din-male.jpg' },
      '4310din-male-ra': { name: '4.3/10 DIN Male - Right Angle', series: '4.3/10 DIN', gender: 'Male', type: 'Right Angle', orientable: true, image: '4310din-male-ra.jpg' },
      '4310din-female': { name: '4.3/10 DIN Female', series: '4.3/10 DIN', gender: 'Female', type: 'Standard', orientable: false, image: '4310din-female.jpg' },
      '4310din-female-bulkhead': { name: '4.3/10 DIN Female - Bulkhead', series: '4.3/10 DIN', gender: 'Female', type: 'Bulkhead', orientable: false, image: '4310din-female-bulkhead.jpg' },
      '4310din-female-ra-bulkhead': { name: '4.3/10 DIN Female - Right Angle Bulkhead', series: '4.3/10 DIN', gender: 'Female', type: 'Right Angle Bulkhead', orientable: false, image: '4310din-female-ra-bulkhead.jpg' },
      
      // 2.92mm Series
      '292mm-male': { name: '2.92mm Male', series: '2.92mm', gender: 'Male', type: 'Precision', orientable: false, image: '292mm-male.jpg' },
      '292mm-female': { name: '2.92mm Female', series: '2.92mm', gender: 'Female', type: 'Precision', orientable: false, image: '292mm-female.jpg' },
      '292mm-female-bulkhead': { name: '2.92mm Female - Bulkhead', series: '2.92mm', gender: 'Female', type: 'Bulkhead', orientable: false, image: '292mm-female-bulkhead.jpg' },
      
      // 2.4mm Series
      '24mm-male': { name: '2.4mm Male', series: '2.4mm', gender: 'Male', type: 'Precision', orientable: false, image: '24mm-male.jpg' },
      '24mm-female': { name: '2.4mm Female', series: '2.4mm', gender: 'Female', type: 'Precision', orientable: false, image: '24mm-female.jpg' },
      
      // 1.85mm Series
      '185mm-male': { name: '1.85mm Male', series: '1.85mm', gender: 'Male', type: 'Precision', orientable: false, image: '185mm-male.jpg' },
      '185mm-female': { name: '1.85mm Female', series: '1.85mm', gender: 'Female', type: 'Precision', orientable: false, image: '185mm-female.jpg' },
      
      // 1.0mm Series
      '10mm-male': { name: '1.0mm Male', series: '1.0mm', gender: 'Male', type: 'Precision', orientable: false, image: '10mm-male.jpg' },
      '10mm-female': { name: '1.0mm Female', series: '1.0mm', gender: 'Female', type: 'Precision', orientable: false, image: '10mm-female.jpg' },
      
      // HN Series
      'hn-male': { name: 'HN Male - Straight', series: 'HN', gender: 'Male', type: 'Straight', orientable: true, image: 'hn-male.jpg' },
      'hn-male-ra': { name: 'HN Male - Right Angle', series: 'HN', gender: 'Male', type: 'Right Angle', orientable: true, image: 'hn-male-ra.jpg' },
      'hn-female-bulkhead': { name: 'HN Female - Bulkhead', series: 'HN', gender: 'Female', type: 'Bulkhead', orientable: false, image: 'hn-female-bulkhead.jpg' },
      
      // SMP Series
      'smp-male': { name: 'SMP Male - Straight', series: 'SMP', gender: 'Male', type: 'Straight', orientable: true, image: 'smp-male.jpg' },
      'smp-male-ra': { name: 'SMP Male - Right Angle', series: 'SMP', gender: 'Male', type: 'Right Angle', orientable: true, image: 'smp-male-ra.jpg' },
      'smp-male-bulkhead': { name: 'SMP Male - Bulkhead', series: 'SMP', gender: 'Male', type: 'Bulkhead', orientable: false, image: 'smp-male-bulkhead.jpg' },
      'smp-female': { name: 'SMP Female - Straight', series: 'SMP', gender: 'Female', type: 'Straight', orientable: true, image: 'smp-female.jpg' },
      'smp-female-ra': { name: 'SMP Female - Right Angle', series: 'SMP', gender: 'Female', type: 'Right Angle', orientable: true, image: 'smp-female-ra.jpg' },
      
      // Other Series
      'other-connector': { name: 'Other (Custom)', series: 'Other', gender: 'N/A', type: 'Custom', orientable: false, image: 'other-connector.jpg' }
    };
  }

  initializeImages() {
    // Set up initial image display state
    this.updateLeftConnectorImage();
    this.updateRightConnectorImage();
    this.updateCableImage();
    this.updateCableLengthDisplay();
  }

  // ========================================
  // Image Display Methods
  // ========================================

  updateLeftConnectorImage() {
    const leftConnectorSelect = document.getElementById('left-connector');
    if (!leftConnectorSelect) {
      console.error('Left connector select element not found');
      return;
    }
    
    const leftConnector = leftConnectorSelect.value;
    const spec = this.connectorSpecs[leftConnector];
    
    if (!this.leftConnectorImage || !this.leftConnectorPlaceholder || !this.leftConnectorName) {
      console.error('Left connector image elements not found');
      return;
    }
    
    if (spec && spec.image) {
      const imageUrl = this.imageBasePath + spec.image;
      console.log('Loading left connector image:', imageUrl);
      
      this.leftConnectorImage.src = imageUrl;
      this.leftConnectorImage.style.display = 'block';
      this.leftConnectorPlaceholder.style.display = 'none';
      this.leftConnectorName.textContent = spec.name;
      
      // Handle image load success
      this.leftConnectorImage.onload = () => {
        console.log('✓ Left connector image loaded:', spec.image);
      };
      
      // Handle image load error
      this.leftConnectorImage.onerror = () => {
        console.error('✗ Left connector image failed:', imageUrl);
        this.leftConnectorImage.style.display = 'none';
        this.leftConnectorPlaceholder.style.display = 'flex';
        this.leftConnectorPlaceholder.innerHTML = `<span>Image not available<br>${spec.name}<br><small>Expected: ${spec.image}</small></span>`;
      };
    } else {
      this.leftConnectorImage.style.display = 'none';
      this.leftConnectorPlaceholder.style.display = 'flex';
      this.leftConnectorPlaceholder.innerHTML = '<span>Select left connector</span>';
      this.leftConnectorName.textContent = '';
    }
  }

  updateRightConnectorImage() {
    const rightConnectorSelect = document.getElementById('right-connector');
    if (!rightConnectorSelect) {
      console.error('Right connector select element not found');
      return;
    }
    
    const rightConnector = rightConnectorSelect.value;
    const spec = this.connectorSpecs[rightConnector];
    
    if (!this.rightConnectorImage || !this.rightConnectorPlaceholder || !this.rightConnectorName) {
      console.error('Right connector image elements not found');
      return;
    }
    
    if (spec && spec.image) {
      const imageUrl = this.imageBasePath + spec.image;
      console.log('Loading right connector image:', imageUrl);
      
      this.rightConnectorImage.src = imageUrl;
      this.rightConnectorImage.style.display = 'block';
      this.rightConnectorPlaceholder.style.display = 'none';
      this.rightConnectorName.textContent = spec.name;
      
      // Handle image load success
      this.rightConnectorImage.onload = () => {
        console.log('✓ Right connector image loaded:', spec.image);
      };
      
      // Handle image load error
      this.rightConnectorImage.onerror = () => {
        console.error('✗ Right connector image failed:', imageUrl);
        this.rightConnectorImage.style.display = 'none';
        this.rightConnectorPlaceholder.style.display = 'flex';
        this.rightConnectorPlaceholder.innerHTML = `<span>Image not available<br>${spec.name}<br><small>Expected: ${spec.image}</small></span>`;
      };
    } else {
      this.rightConnectorImage.style.display = 'none';
      this.rightConnectorPlaceholder.style.display = 'flex';
      this.rightConnectorPlaceholder.innerHTML = '<span>Select right connector</span>';
      this.rightConnectorName.textContent = '';
    }
  }

  updateCableImage() {
    const cableTypeSelect = document.getElementById('cable-type');
    if (!cableTypeSelect) {
      console.error('Cable type select element not found');
      return;
    }
    
    const cableType = cableTypeSelect.value;
    const spec = this.cableSpecs[cableType];
    
    if (!this.cableImage || !this.cablePlaceholder || !this.cableName) {
      console.error('Cable image elements not found');
      return;
    }
    
    if (spec && cableType) {
      // Auto-generate filename from cable type: convert to uppercase and add .jpg
      const imageFilename = cableType.toUpperCase() + '.jpg';
      const imageUrl = this.imageBasePath + imageFilename;
      console.log('Loading cable image:', imageUrl);
      console.log('Cable type:', cableType, '| Expected filename:', imageFilename);
      
      this.cableImage.src = imageUrl;
      this.cableImage.style.display = 'block';
      this.cablePlaceholder.style.display = 'none';
      this.cableName.textContent = spec.name;
      
      // Handle image load success
      this.cableImage.onload = () => {
        console.log('✓ Cable image loaded successfully:', imageFilename);
      };
      
      // Handle image load error
      this.cableImage.onerror = () => {
        console.error('✗ Cable image failed to load:', imageUrl);
        console.error('Upload image with exact name:', imageFilename);
        this.cableImage.style.display = 'none';
        this.cablePlaceholder.style.display = 'flex';
        this.cablePlaceholder.innerHTML = `<span>Image not available<br>${spec.name}<br><small>Upload: ${imageFilename}</small></span>`;
      };
    } else {
      this.cableImage.style.display = 'none';
      this.cablePlaceholder.style.display = 'flex';
      this.cablePlaceholder.innerHTML = '<span>Select cable type</span>';
      this.cableName.textContent = '';
    }
    
    this.updateCableLengthDisplay();
  }

  updateCableLengthDisplay() {
    const lengthInput = document.getElementById('cable-length');
    const unitSelect = document.getElementById('length-unit');
    const cableTypeSelect = document.getElementById('cable-type');
    
    if (!lengthInput || !unitSelect || !cableTypeSelect || !this.cableLengthDisplay) {
      return;
    }
    
    const length = lengthInput.value;
    const unit = unitSelect.value;
    const cableType = cableTypeSelect.value;
    
    if (length && unit && cableType) {
      this.cableLengthDisplay.textContent = `${length} ${unit}`;
      this.cableLengthDisplay.style.display = 'block';
    } else {
      this.cableLengthDisplay.style.display = 'none';
    }
  }

  // ========================================
  // Modal Methods
  // ========================================

  openQuoteModal() {
    const validation = this.validateForm();
    if (!validation.isValid) {
      alert('Please complete the configuration before requesting a quote:\n\n' + validation.errors.join('\n'));
      return;
    }
    
    this.updateQuoteConfigurationSummary();
    this.quoteModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    setTimeout(() => {
      const firstInput = this.quoteForm.querySelector('input[type="text"]');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  closeQuoteModal() {
    this.quoteModal.style.display = 'none';
    document.body.style.overflow = '';
    this.quoteForm.reset();
  }

  updateQuoteConfigurationSummary() {
    const config = this.getFormData();
    let summaryHTML = this.generateSummaryHTML(config);
    
    if (this.isConfigurationComplete(config)) {
      const partNumber = this.generatePartNumber(config);
      summaryHTML += this.createConfigItem('Generated Part Number', partNumber);
    }
    
    this.quoteConfigSummary.innerHTML = summaryHTML;
  }

  async handleQuoteSubmission(e) {
    e.preventDefault();
    
    const submitButton = this.quoteForm.querySelector('.btn-submit');
    const originalText = submitButton.textContent;
    
    submitButton.disabled = true;
    submitButton.textContent = 'Sending...';
    
    try {
      const formData = new FormData(this.quoteForm);
      const config = this.getFormData();
      
      const quoteData = {
        firstName: formData.get('first_name'),
        lastName: formData.get('last_name'),
        email: formData.get('email'),
        phone: formData.get('phone') || 'Not provided',
        company: formData.get('company') || 'Not specified',
        requirements: formData.get('requirements') || 'No additional requirements',
        configuration: this.generateDetailedConfiguration(config),
        partNumber: this.generatePartNumber(config),
        timestamp: new Date().toLocaleString()
      };
      
      const success = await this.sendQuoteRequest(quoteData);
      
      if (success) {
        this.showSuccessMessage();
        this.closeQuoteModal();
      } else {
        throw new Error('Failed to send quote request');
      }
      
    } catch (error) {
      console.error('Quote submission error:', error);
      alert('There was an error submitting your quote request. Please try again or contact us directly at Office@telewiretech.com');
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  }

  async sendQuoteRequest(quoteData) {
    try {
      // Web3forms API endpoint - sends email to Office@telewiretech.com
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          access_key: this.web3formsAccessKey,
          subject: `Cable Assembly Quote Request from ${quoteData.firstName} ${quoteData.lastName}`,
          from_name: `${quoteData.firstName} ${quoteData.lastName}`,
          email: quoteData.email,
          name: `${quoteData.firstName} ${quoteData.lastName}`,
          phone: quoteData.phone,
          company: quoteData.company,
          message: this.formatQuoteEmail(quoteData),
          to: 'Office@telewiretech.com',
          replyto: quoteData.email
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        console.log('Quote request sent successfully via Web3forms');
        console.log('Email notification will be sent to Office@telewiretech.com');
        return true;
      } else {
        console.error('Web3forms error:', result.message);
        return false;
      }
      
    } catch (error) {
      console.error('Form submission error:', error);
      return false;
    }
  }

  formatQuoteEmail(quoteData) {
    return `
TO: Office@telewiretech.com

CABLE ASSEMBLY QUOTE REQUEST
================================================================

CUSTOMER INFORMATION:
--------------------
Name:            ${quoteData.firstName} ${quoteData.lastName}
Email:           ${quoteData.email}
Phone:           ${quoteData.phone}
Company:         ${quoteData.company}
Request Date:    ${quoteData.timestamp}

CABLE CONFIGURATION DETAILS:
----------------------------
${quoteData.configuration}

GENERATED PART NUMBER:
---------------------
${quoteData.partNumber}

ADDITIONAL REQUIREMENTS:
-----------------------
${quoteData.requirements}

================================================================
Please provide pricing, lead time, and availability for the above configuration.

This request was submitted through the Cable Builder at:
${window.location.href}
    `.trim();
  }

  generateDetailedConfiguration(config) {
    let details = '';
    
    if (config.cableType) {
      const spec = this.cableSpecs[config.cableType];
      details += `- Cable Type: ${spec ? spec.name : config.cableType}\n`;
    }
    
    if (config.cableLength && config.lengthUnit) {
      const lengthInMm = this.convertLength(parseFloat(config.cableLength), config.lengthUnit).mm;
      details += `- Length: ${config.cableLength} ${config.lengthUnit} (${lengthInMm.toFixed(1)} mm)\n`;
    }
    
    if (config.leftConnector) {
      const spec = this.connectorSpecs[config.leftConnector];
      details += `- Left Connector: ${spec ? spec.name : config.leftConnector}\n`;
    }
    
    if (config.rightConnector) {
      const spec = this.connectorSpecs[config.rightConnector];
      details += `- Right Connector: ${spec ? spec.name : config.rightConnector}\n`;
    }
    
    if (config.orientation) {
      details += `- Orientation: ${config.orientation.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}\n`;
    }
    
    if (config.extraRequirements) {
      details += `- Extra Requirements: ${config.extraRequirements}\n`;
    }
    
    details += `- Quantity: ${config.quantity} piece${config.quantity !== 1 ? 's' : ''}\n`;
    
    return details;
  }

  showSuccessMessage() {
    const message = document.createElement('div');
    message.className = 'success-message';
    message.innerHTML = `
      <strong>Quote Request Submitted Successfully!</strong><br>
      Your cable assembly quote request has been sent to our team. We'll respond within 24 hours via email.
    `;
    
    if (this.configuratorTop && this.configuratorTop.parentNode) {
      this.configuratorTop.parentNode.insertBefore(message, this.configuratorTop);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.remove('show');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 5000);
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // ========================================
  // Configuration Methods
  // ========================================

  getFormData() {
    const formData = new FormData(this.form);
    return {
      cableType: formData.get('cable_type') || '',
      cableLength: formData.get('cable_length') || '',
      lengthUnit: formData.get('length_unit') || 'mm',
      leftConnector: formData.get('left_connector') || '',
      rightConnector: formData.get('right_connector') || '',
      orientation: formData.get('connector_orientation') || '',
      extraRequirements: formData.get('extra_requirements') || '',
      quantity: parseInt(formData.get('quantity')) || 1
    };
  }

  updateConfiguration() {
    const config = this.getFormData();
    this.updateSummaryDisplay(config);
    this.updatePartNumber(config);
    this.updateTechnicalSpecs(config);
    this.updateRequestQuoteButton(config);
    this.updateSampleLabel(config);
  }

  updateSampleLabel(config) {
    const sampleLabel = document.getElementById('sample-label');
    if (sampleLabel && this.isConfigurationComplete(config)) {
      sampleLabel.style.display = 'block';
    } else if (sampleLabel) {
      sampleLabel.style.display = 'none';
    }
  }

  updateRequestQuoteButton(config) {
    if (!this.requestQuoteBtn) return;
    
    const isComplete = this.isConfigurationComplete(config);
    this.requestQuoteBtn.disabled = !isComplete;
    
    if (isComplete) {
      this.requestQuoteBtn.innerHTML = '<span class="btn-icon">✉</span> Send Request for Quote';
    } else {
      this.requestQuoteBtn.innerHTML = '<span class="btn-icon">⚠</span> Complete Configuration First';
    }
  }

  updateSummaryDisplay(config) {
    // Update right panel with Cable Specifications only
    if (!this.summaryDisplay) return;
    
    let summaryHTML = '';
    
    if (config.cableType) {
      // Show cable details in the right panel
      summaryHTML += this.generateCableDetailsHTML(config.cableType);
    } else {
      summaryHTML = '<div class="summary-placeholder"><p>Configure your cable assembly using the form to see a real-time summary of your specifications.</p></div>';
    }
    
    this.summaryDisplay.innerHTML = summaryHTML;
    
    // Update "Your Configuration" section underneath images
    if (this.configDetailsUnderImage && this.yourConfigSection) {
      if (this.isConfigurationComplete(config)) {
        this.configDetailsUnderImage.innerHTML = this.generateSummaryHTML(config);
        this.yourConfigSection.style.display = 'block';
      } else if (config.cableType || config.leftConnector || config.rightConnector || config.cableLength) {
        // Show partial configuration
        this.configDetailsUnderImage.innerHTML = this.generateSummaryHTML(config);
        this.yourConfigSection.style.display = 'block';
      } else {
        this.yourConfigSection.style.display = 'none';
      }
    }
  }

  generateSummaryHTML(config) {
    let html = '';
    
    if (config.cableType) {
      const cableSpec = this.cableSpecs[config.cableType];
      html += this.createConfigItem('Cable Type', cableSpec ? cableSpec.name : config.cableType);
    }
    
    if (config.cableLength && config.lengthUnit) {
      html += this.createConfigItem('Cable Length', `${config.cableLength} ${config.lengthUnit}`);
    }
    
    if (config.leftConnector) {
      const leftSpec = this.connectorSpecs[config.leftConnector];
      html += this.createConfigItem('Left Connector', leftSpec ? leftSpec.name : config.leftConnector);
    }
    
    if (config.rightConnector) {
      const rightSpec = this.connectorSpecs[config.rightConnector];
      html += this.createConfigItem('Right Connector', rightSpec ? rightSpec.name : config.rightConnector);
    }
    
    if (config.orientation) {
      html += this.createConfigItem('Orientation', config.orientation.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()));
    }
    
    if (config.extraRequirements) {
      html += this.createConfigItem('Extra Requirements', config.extraRequirements);
    }
    
    html += this.createConfigItem('Quantity', `${config.quantity} piece${config.quantity !== 1 ? 's' : ''}`);
    
    return html;
  }

  createConfigItem(label, value) {
    return `
      <div class="config-item">
        <div class="config-label">${label}:</div>
        <div class="config-value">${value}</div>
      </div>
    `;
  }

  isConfigurationComplete(config) {
    return config.cableType && config.cableLength && config.leftConnector && config.rightConnector;
  }

  checkOrientation() {
    const leftConnectorSelect = document.getElementById('left-connector');
    const rightConnectorSelect = document.getElementById('right-connector');
    
    if (!leftConnectorSelect || !rightConnectorSelect) return;
    
    const leftConnector = leftConnectorSelect.value;
    const rightConnector = rightConnectorSelect.value;
    
    const leftSpec = this.connectorSpecs[leftConnector];
    const rightSpec = this.connectorSpecs[rightConnector];
    
    const showOrientation = leftSpec && rightSpec && leftSpec.orientable && rightSpec.orientable;
    
    if (this.orientationSection) {
      if (showOrientation) {
        this.orientationSection.style.display = 'block';
      } else {
        this.orientationSection.style.display = 'none';
        const orientationSelect = document.getElementById('connector-orientation');
        if (orientationSelect) orientationSelect.value = '';
      }
    }
  }

  updateLengthConversion() {
    const lengthInput = document.getElementById('cable-length');
    const unitSelect = document.getElementById('length-unit');
    
    if (!lengthInput || !unitSelect || !this.lengthConversion) return;
    
    const length = parseFloat(lengthInput.value);
    const unit = unitSelect.value;
    
    if (length && unit) {
      const conversions = this.convertLength(length, unit);
      let conversionText = 'Conversions: ';
      
      if (unit !== 'mm') conversionText += `${conversions.mm.toFixed(1)} mm`;
      if (unit !== 'inches') conversionText += `${unit !== 'mm' ? ', ' : ''}${conversions.inches.toFixed(2)} inches`;
      if (unit !== 'cm') conversionText += `, ${conversions.cm.toFixed(1)} cm`;
      if (unit !== 'meters') conversionText += `, ${conversions.meters.toFixed(3)} meters`;
      
      this.lengthConversion.textContent = conversionText;
      this.lengthConversion.classList.add('active');
    } else {
      this.lengthConversion.classList.remove('active');
    }
  }

  convertLength(value, fromUnit) {
    let mm;
    switch (fromUnit) {
      case 'mm': mm = value; break;
      case 'cm': mm = value * 10; break;
      case 'inches': mm = value * 25.4; break;
      case 'meters': mm = value * 1000; break;
      case 'feet': mm = value * 304.8; break;
      default: mm = value;
    }
    
    return {
      mm: mm,
      cm: mm / 10,
      inches: mm / 25.4,
      meters: mm / 1000,
      feet: mm / 304.8
    };
  }

  updatePartNumber(config) {
    if (!this.partNumberSection || !this.partNumberDisplay) return;
    
    if (this.isConfigurationComplete(config)) {
      const partNumber = this.generatePartNumber(config);
      this.partNumberDisplay.textContent = partNumber;
      this.partNumberSection.style.display = 'block';
    } else {
      this.partNumberSection.style.display = 'none';
    }
  }

  generatePartNumber(config) {
    let partNumber = 'CBL-';
    
    // Cable type abbreviation - EXPANDED
    const cableAbbr = {
      'rg141': 'RG141',
      'rg142': 'RG142',
      'rg174': 'RG174',
      'rg178': 'RG178',
      'rg188': 'RG188',
      'rg196': 'RG196',
      'rg213': 'RG213',
      'rg214': 'RG214',
      'rg217': 'RG217',
      'rg218': 'RG218',
      'rg223': 'RG223',
      'rg225': 'RG225',
      'rg303': 'RG303',
      'rg316': 'RG316',
      'rg316-ds': 'RG316DS',
      'rg393': 'RG393',
      'rg400': 'RG400',
      'rg55': 'RG55',
      'rg58': 'RG58',
      'rg58-p': 'RG58P',
      'rg8': 'RG8',
      'rg8x': 'RG8X',
      'lmr-100a-fr': 'LMR100AFR',
      'lmr-100a': 'LMR100A',
      'lmr-100a-uf': 'LMR100AUF',
      'lmr-195': 'LMR195',
      'lmr-195-fr': 'LMR195FR',
      'lmr-195-llpl': 'LMR195LLPL',
      'lmr-195-llpx': 'LMR195LLPX',
      'lmr-195-uf': 'LMR195UF',
      'lmr-200': 'LMR200',
      'lmr-200-fr': 'LMR200FR',
      'lmr-200-uf': 'LMR200UF',
      'lmr-240': 'LMR240',
      'lmr-240-db': 'LMR240DB',
      'lmr-240-fr': 'LMR240FR',
      'lmr-240-llpx': 'LMR240LLPX',
      'lmr-240-uf': 'LMR240UF',
      'lmr-400': 'LMR400',
      'lmr-400-db': 'LMR400DB',
      'lmr-400-fr': 'LMR400FR',
      'lmr-400-llpx': 'LMR400LLPX',
      'lmr-400-uf': 'LMR400UF',
      'lmr-500': 'LMR500',
      'lmr-500-db': 'LMR500DB',
      'lmr-500-uf': 'LMR500UF',
      'lmr-600': 'LMR600',
      'lmr-600-db': 'LMR600DB',
      'lmr-600-fr': 'LMR600FR',
      'lmr-600-llpx': 'LMR600LLPX',
      'lmr-600-uf': 'LMR600UF',
      'lmr-900-db': 'LMR900DB',
      'lmr-lw195': 'LMRLW195',
      'lmr-lw240': 'LMRLW240',
      'lmr-lw400': 'LMRLW400',
      'lmr-lw600': 'LMRLW600',
      'rg402-tinned': 'RG402TINNED',
      'rg405-tinned': 'RG405TINNED',
      'rg401': 'RG401',
      'rg402': 'RG402',
      'rg405': 'RG405',
      '1-2-flexible': '12FLEXIBLE',
      '1-2-superflexible': '12SUPERFLEXI',
      '1-4-superflexible': '14SUPERFLEXI',
      'spf-250': 'SPF250',
      'spf-375': 'SPF375',
      'spf-500': 'SPF500',
      'spo-250': 'SPO250',
      'spo-375': 'SPO375',
      'spo-500': 'SPO500',
      'spp-250-llpl': 'SPP250LLPL',
      'spp-375-llpl': 'SPP375LLPL',
      'spp-500-llpl': 'SPP500LLPL',
      'tcom-195': 'TCOM195',
      'tcom-195-fr': 'TCOM195FR',
      'tcom-240': 'TCOM240',
      'tcom-240-fr': 'TCOM240FR',
      'tcom-400': 'TCOM400',
      'tcom-400-fr': 'TCOM400FR',
      'tcom-600': 'TCOM600',
      'tcom-600-fr': 'TCOM600FR',
      'tft-5g-402': 'TFT5G402',
      'rg174nm': 'RG174NM',
      'mini-59': 'MINI59',
      'rg11': 'RG11',
      'rg179': 'RG179',
      'rg187': 'RG187',
      'rg302': 'RG302',
      'rg59': 'RG59',
      'rg59-p': 'RG59P',
      'rg6': 'RG6',
      'rg6-catv': 'RG6CATV',
      'lmr-240-75-db': 'LMR24075DB',
      'lmr-400-75': 'LMR40075',
      'lmr-400-75-db': 'LMR40075DB',
      'lmr-600-75-db': 'LMR60075DB',
      'rg62': 'RG62',
      'rg180': 'RG180',
      'rg108': 'RG108',
      'other-cable': 'OTHER',
    };
    
    partNumber += cableAbbr[config.cableType] || config.cableType.toUpperCase();
    partNumber += '-';
    
    // Length in mm
    const lengthInMm = this.convertLength(parseFloat(config.cableLength), config.lengthUnit).mm;
    partNumber += Math.round(lengthInMm);
    partNumber += '-';
    
    // Connector abbreviations
    const connectorAbbr = {
      // SMA Series
      'sma-male': 'SMAM',
      'sma-male-ra': 'SMAMRA',
      'sma-male-bulkhead': 'SMAMBH',
      'sma-female': 'SMAF',
      'sma-female-ra': 'SMAFRA',
      'sma-female-bulkhead': 'SMAFBH',
      'rp-sma-male': 'RPSMAM',
      'rp-sma-female': 'RPSMAF',
      
      // SMB Series
      'smb-male': 'SMBM',
      'smb-male-ra': 'SMBMRA',
      'smb-female': 'SMBF',
      'smb-female-ra': 'SMBFRA',
      
      // SMC Series
      'smc-male': 'SMCM',
      'smc-male-ra': 'SMCMRA',
      'smc-female': 'SMCF',
      'smc-female-ra': 'SMCFRA',
      
      // BNC Series
      'bnc-male-50': 'BNCM50',
      'bnc-male-50-ra': 'BNCM50RA',
      'bnc-male-50-bulkhead': 'BNCM50BH',
      'bnc-female-50': 'BNCF50',
      'bnc-female-50-bulkhead': 'BNCF50BH',
      'bnc-male-75': 'BNCM75',
      'bnc-female-75': 'BNCF75',
      
      // N-Type Series
      'n-male': 'NM',
      'n-male-ra': 'NMRA',
      'n-male-bulkhead': 'NMBH',
      'n-female': 'NF',
      'n-female-bulkhead': 'NFBH',
      'rp-n-male': 'RPNM',
      'rp-n-female': 'RPNF',
      
      // TNC Series
      'tnc-male': 'TNCM',
      'tnc-male-ra': 'TNCMRA',
      'tnc-female': 'TNCF',
      'tnc-female-ra': 'TNCFRA',
      'rp-tnc-male': 'RPTNCM',
      'rp-tnc-female': 'RPTNCF',
      
      // UHF/PL Series
      'pl-259': 'PL259',
      'so-239': 'SO239',
      
      // MCX Series
      'mcx-male': 'MCXM',
      'mcx-male-ra': 'MCXMRA',
      'mcx-female': 'MCXF',
      'mcx-female-ra': 'MCXFRA',
      
      // MMCX Series
      'mmcx-male': 'MMCXM',
      'mmcx-male-ra': 'MMCXMRA',
      'mmcx-female': 'MMCXF',
      'mmcx-female-ra': 'MMCXFRA',
      
      // F-Type Series
      'f-male': 'FM',
      'f-male-ra': 'FMRA',
      'f-female': 'FF',
      'f-female-bulkhead': 'FFBH',
      
      // QMA Series
      'qma-male': 'QMAM',
      'qma-male-ra': 'QMAMRA',
      'qma-female': 'QMAF',
      'qma-female-bulkhead': 'QMAFBH',
      
      // QN Series
      'qn-male': 'QNM',
      'qn-male-ra': 'QNMRA',
      'qn-female': 'QNF',
      'qn-female-bulkhead': 'QNFBH',
      
      // 7/16 DIN Series
      '716din-male': '716DINM',
      '716din-male-ra': '716DINMRA',
      '716din-female': '716DINF',
      '716din-female-bulkhead': '716DINFBH',
      
      // U.FL Series
      'ufl-male': 'UFLM',
      'ufl-female': 'UFLF',
      
      // Open Terminal
      'open-terminal': 'OPEN',
      
      // 1.0/2.3 Series
      '1023-male': '1023M',
      '1023-male-ra': '1023MRA',
      '1023-female-bulkhead': '1023FBH',
      '1023-female-ra-bulkhead': '1023FRABH',
      
      // 4.3/10 DIN Series
      '4310din-male': '4310M',
      '4310din-male-ra': '4310MRA',
      '4310din-female': '4310F',
      '4310din-female-bulkhead': '4310FBH',
      '4310din-female-ra-bulkhead': '4310FRABH',
      
      // 2.92mm Series
      '292mm-male': '292M',
      '292mm-female': '292F',
      '292mm-female-bulkhead': '292FBH',
      
      // 2.4mm Series
      '24mm-male': '24M',
      '24mm-female': '24F',
      
      // 1.85mm Series
      '185mm-male': '185M',
      '185mm-female': '185F',
      
      // 1.0mm Series
      '10mm-male': '10M',
      '10mm-female': '10F',
      
      // HN Series
      'hn-male': 'HNM',
      'hn-male-ra': 'HNMRA',
      'hn-female-bulkhead': 'HNFBH',
      
      // SMP Series
      'smp-male': 'SMPM',
      'smp-male-ra': 'SMPMRA',
      'smp-male-bulkhead': 'SMPMBH',
      'smp-female': 'SMPF',
      'smp-female-ra': 'SMPFRA',
      
      // Other
      'other-connector': 'CUSTOM'
    };
    
    partNumber += connectorAbbr[config.leftConnector] || config.leftConnector.toUpperCase();
    partNumber += '-';
    partNumber += connectorAbbr[config.rightConnector] || config.rightConnector.toUpperCase();
    
    // Add orientation if specified
    if (config.orientation) {
      const orientationAbbr = {
        '0-degrees': '0',
        '45-degrees': '45',
        '90-degrees': '90',
        '135-degrees': '135',
        '180-degrees': '180'
      };
      partNumber += '-' + orientationAbbr[config.orientation];
    }
    
    return partNumber;
  }

  updateTechnicalSpecs(config) {
    if (!this.techSpecs || !this.specsContent) return;
    
    if (this.isConfigurationComplete(config)) {
      const specs = this.generateTechnicalSpecs(config);
      this.specsContent.innerHTML = specs;
      this.techSpecs.style.display = 'block';
    } else {
      this.techSpecs.style.display = 'none';
    }
  }

  generateTechnicalSpecs(config) {
    const cableSpec = this.cableSpecs[config.cableType];
    if (!cableSpec) return '';
    
    const lengthInMm = this.convertLength(parseFloat(config.cableLength), config.lengthUnit).mm;
    const lengthInFt = lengthInMm / 304.8;
    
    let html = '';
    html += this.createSpecItem('Impedance', cableSpec.impedance);
    html += this.createSpecItem('Max Frequency', cableSpec.maxFreq);
    html += this.createSpecItem('Cable Diameter', cableSpec.diameter);
    html += this.createSpecItem('Temperature Range', cableSpec.tempRange);
    
    // Calculate approximate attenuation
    if (cableSpec.attenuation) {
      const attenuationPerFt = parseFloat(cableSpec.attenuation.match(/[\d.]+/)[0]);
      const totalAttenuation = (attenuationPerFt * lengthInFt).toFixed(2);
      html += this.createSpecItem('Est. Attenuation @ 1GHz', `${totalAttenuation} dB`);
    }
    
    html += this.createSpecItem('Assembled Length', `${config.cableLength} ${config.lengthUnit} (${lengthInMm.toFixed(1)} mm)`);
    
    return html;
  }


  generateCableDetailsHTML(cableType) {
    const cableSpec = this.cableSpecs[cableType];
    if (!cableSpec) return '';
    
    let html = '<div class="cable-details-section">';
    html += '<h4 class="cable-details-title">Cable Specifications</h4>';
    html += '<div class="cable-details-grid">';
    
    // Helper to add spec item only if value exists and is not N/A
    const addSpec = (label, value) => {
      if (value && value !== 'N/A' && value.trim() !== '') {
        html += `<div class="spec-detail-item">`;
        html += `<span class="spec-detail-label">${label}:</span>`;
        html += `<span class="spec-detail-value">${value}</span>`;
        html += `</div>`;
      }
    };
    
    // Display specs in organized order
    addSpec('Cable Type', cableSpec.name);
    addSpec('Design', cableSpec.design);
    addSpec('Flex Type', cableSpec.flexType);
    addSpec('Impedance', cableSpec.impedance);
    addSpec('Dielectric Type', cableSpec.dielectricType);
    addSpec('Velocity of Propagation', cableSpec.velocity);
    addSpec('Jacket Diameter', cableSpec.jacketDiameter);
    addSpec('Jacket Material', cableSpec.jacketMaterial);
    addSpec('Number of Shields', cableSpec.numShields);
    addSpec('Attenuation @ 1GHz', cableSpec.attenuation);
    addSpec('RF Shielding', cableSpec.rfShielding);
    addSpec('Max Frequency', cableSpec.maxFreq);
    addSpec('Temperature Range', cableSpec.tempRange);
    addSpec('Center Conductor Type', cableSpec.conductorType);
    addSpec('Conductor Strands', cableSpec.conductorStrands);
    addSpec('Min Bend Radius (One Time)', cableSpec.bendRadiusOnce);
    addSpec('Min Bend Radius (Repeated)', cableSpec.bendRadiusRepeated);
    
    html += '</div>';
    html += '</div>';
    
    return html;
  }


  createSpecItem(label, value) {
    return `
      <div class="spec-item">
        <div class="spec-label">${label}:</div>
        <div class="spec-value">${value}</div>
      </div>
    `;
  }

  // ========================================
  // Public Methods
  // ========================================

  getConfiguration() {
    return this.getFormData();
  }

  resetForm() {
    if (this.form) {
      this.form.reset();
      this.updateConfiguration();
      this.checkOrientation();
      this.initializeImages();
    }
  }

  validateForm() {
    const config = this.getFormData();
    const errors = [];
    
    if (!config.cableType) errors.push('Please select a cable type');
    if (!config.cableLength) errors.push('Please enter cable length');
    if (!config.leftConnector) errors.push('Please select left connector');
    if (!config.rightConnector) errors.push('Please select right connector');
    if (config.cableLength && (parseFloat(config.cableLength) <= 0)) errors.push('Cable length must be greater than 0');
    if (config.quantity <= 0) errors.push('Quantity must be at least 1');
    
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing Cable Builder...');
  try {
    window.cableBuilder = new CableBuilder();
    console.log('Cable Builder initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Cable Builder:', error);
  }
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CableBuilder;
}